import { render, staticRenderFns } from "./wsAvalonNavigationList.vue?vue&type=template&id=72a4fde3&scoped=true&"
import script from "./wsAvalonNavigationList.vue?vue&type=script&lang=js&"
export * from "./wsAvalonNavigationList.vue?vue&type=script&lang=js&"
import style0 from "./wsAvalonNavigationList.vue?vue&type=style&index=0&id=72a4fde3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a4fde3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VExpandTransition,VHover,VIcon,VImg,VSheet})


/* vuetify-loader */
import installDirectives from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
